module.exports = "<footer class=\"hidden-print\">\n    <div class=\"container-fluid\">\n        <a id=\"logo-alterdata\" [href]=\"urlSiteAlterdata\" target=\"_blank\" class=\"hidden-xs\" [colTooltip]=\"'Alterdata Software'\">\n            Alterdata Software\n        </a>\n        <p class=\"hidden-xs\">©1989 - {{anoAtual}} - Alterdata Software - Direitos reservados</p>\n\n        <p class=\"visible-xs\">\n            ©{{anoAtual}} -\n            <a [href]=\"urlSiteAlterdata\" target=\"_blank\">Alterdata Software</a>\n        </p>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main